<script setup>
import DropdownRow from "@/components/global-themed/inputs/dropdown/DropdownRow.vue";
import BaseDropdown from "@/components/global-themed/inputs/dropdown/BaseDropdown.vue";
import {computed, ref} from "vue";
import RejectButton from "@/components/approval-center/partials/buttons/RejectButton.vue";

const props = defineProps({
  approval: {
    type: Object,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
  isManualRevise: {
    type: Boolean,
    default: false,
  }
})

const emit = defineEmits(['revise']);

const showDropdown = ref(false);

const rejectShowing = ref(false)

const canShowDropdown = computed(() => props.approval.can_be_rejected);

</script>

<template>
  <BaseDropdown
    v-model:dropdownOpen="showDropdown"
    :disable-click-outside="rejectShowing"
  >
    <template #trigger="{ toggleDropdown }">
      <div
        class="tw-flex tw-cursor-pointer"
      >
        <div
          class="tw-p-3 tw-rounded-xl tw-text-base tw-transition-colors tw-duration-150 tw-border-2 tw-text-primary tw-border-primary tw-flex tw-items-center tw-gap-2 tw-font-bold hover:tw-bg-primary-100"
          :class="{'tw-rounded-r-none': canShowDropdown}"
          @click="emit('revise', approval)"
        >
          <svg-vue
            icon="icons/chat-check"
            class="tw-h-6 tw-w-6"
          />
          {{ isManualRevise ? 'Make Changes' : 'Give Feedback' }}
        </div>
        <div
          v-if="canShowDropdown"
          class="tw-border-2 tw-border-primary tw-text-primary hover:tw-bg-primary-100 tw-border-l-0 tw-flex tw-items-center tw-px-4 tw-rounded-xl tw-rounded-l-none tw-transition-colors tw-duration-150"
          :class="{
            'tw-bg-primary-100': showDropdown,
          }"
          @click="toggleDropdown"
        >
          <svg-vue
            icon="icons/chevron-thick"
            class="tw-h-3 tw-w-3"
          />
        </div>
      </div>
    </template>

    <template #content>
      <DropdownRow
        class="p-0 hover:!tw-bg-transparent"
      >
        <RejectButton
          :category="category"
          :approval="approval"
          @modal-changed="(visible) => rejectShowing = visible"
        />
      </DropdownRow>
    </template>
  </BaseDropdown>
</template>
